import styled from 'styled-components'
import LabelLayout from '../LevelRatingQuestionLabelLayout'
import { ParseSurveyResultDataType } from '../container/modules/parseSurveyResultData'
import LevelRatingTableDesktop from './LevelRatingTable.desktop'
import ResultCardDesktop from './ResultCard.desktop'

interface LevelRatingResultBoxProps {
  surveyResultData: ParseSurveyResultDataType
}

const LevelRatingResultBoxDesktop = ({
  surveyResultData,
}: LevelRatingResultBoxProps) => {
  const { question1, question2, question3, question5, question6, question4 } =
    surveyResultData

  return (
    <StyledWrapper>
      <LabelLayout label={question1.label}>
        <LevelRatingTableDesktop tableDataList={question1.tableDataList} />
      </LabelLayout>
      <LabelLayout label={question2.label}>
        <LevelRatingTableDesktop tableDataList={question2.tableDataList} />
      </LabelLayout>
      <LabelLayout label={question3.label}>
        <ResultCardDesktop
          mainDataText={question3.mainDataText}
          description={question3.description}
          subText={question3.subText}
        />
      </LabelLayout>
      <LabelLayout label={question4.label}>
        {question4.cardList.map((card, index) => {
          return (
            <ResultCardDesktop
              mainDataText={card.mainDataText}
              cardTitle={card.cardTitle}
              description={card.description}
              key={`${card.cardTitle}-${index}`}
            />
          )
        })}
      </LabelLayout>
      <LabelLayout label={question5.label}>
        <ResultCardDesktop
          mainDataText={question5.mainDataText}
          description={question5.description}
          subText={question5.subText}
        />
      </LabelLayout>
      <LabelLayout label={question6.label}>
        {question6.cardList.map((card, index) => {
          return (
            <ResultCardDesktop
              mainDataText={card.mainDataText}
              cardTitle={card.cardTitle}
              subText={card.subText}
              key={`${card.cardTitle}-${index}`}
            />
          )
        })}
      </LabelLayout>
    </StyledWrapper>
  )
}

export default LevelRatingResultBoxDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 48px;
  width: 820px;
  min-height: 300px;
  border-radius: 20px;
  border: solid 1px #e8e8e8e8;
  background-color: #fff;
`
